import Layout from "@/layout";
import ifta from './ifta'

export default {
  path: "/accounting",
  component: Layout,
  meta: { title: "Accounting", icon: "accounting-v2" },
  name: "Accounting",
  alwaysShow: true,
  permissionNoShowFlag:true,
  children: [
    {
      path: "driverSettlement",
      name: "driverSettlement",
      component: () => import("@/views/accounting/views/driverSettlement"),
      meta: { title: "Driver Settlement", keepName: 'driverSettlement', keepAlive: true },
    },
    {
      path: "quickbooks",
      name: "quickbooks",
      component: () => import("@/views/quickbooks"),
      meta: { title: "Quickbooks"},
    },
    {
      path: "accountingInvoice/detail",
      name: "InvoiceDetail",
      component: () => import("@/views/invoice/detail"),
      meta: { activeMenu: '/accounting/driverSettlement',  },
      hidden: true
    },
    {
      path: "accountingInvoice",
      name: "Invoice",
      component: () => import("@/views/invoice/list"),
      meta: { title: "Invoice", keepName: 'accountingInvoice', keepAlive: true },
    },
    {
      path: "expense",
      name: "expense",
      component: () => import("@/views/expense/index.vue"),
      meta: { title: "Expense", keepName: 'Expense', keepAlive: true },
    },
    {
      path: "newexpense",
      name: "newexpense",
      hidden: true,
      component: () => import("@/views/expense/detail.vue"),
      meta: { activeMenu: '/accounting/expense' },
    },
    ifta,
    {
      path: "ifta-edit-report",
      name: "Edit Report",
      component: () => import('@/views/ifta/views/editReport'),
      hidden: true,
      tabHidden: true,
      meta: { activeMenu: '/accounting/ifta-edit-report' }
    }
  ]
}
